module.exports = __webpack_public_path__ + "assets/media/drift-rectangle.067d70ac.svg";